import { getFunctions, httpsCallable } from 'firebase/functions';
import { UserStatus } from '../routes/routing_statuses/RoutingStatuses';
import { Timestamp } from "firebase/firestore";

export const SIGNUP_STEPS = {
  INITIAL: 'INITIAL',
  USER_PROFILE: 'USER_PROFILE',
  ORGANIZATION: 'ORGANIZATION',
  STRIPE_SETUP: 'STRIPE_SETUP',
};

export class SignupError extends Error {
  constructor(message, step, originalError = null) {
    super(message);
    this.step = step;
    this.originalError = originalError;
    this.name = 'SignupError';
  }
}

export const handleSignup = async ({
  email,
  password,
  userProfile,
  organizationDetails,
  step,
  user,
  createUser,
  loginUser,
}) => {
  const functions = getFunctions();
  const createOrganization = httpsCallable(functions, 'createOrganization');

  try {
    switch (step) {
      case 'account':
        // If user is already authenticated, skip account creation
        if (user !== UserStatus.UNAUTHENTICATED) {
          return { success: true };
        }
        
        // Try to create new account
        const authResult = await createUser(email, password);
        if (typeof authResult === 'string') {
          if (authResult === 'auth/email-already-in-use') {
            throw new SignupError(
              'An account with this email already exists. Please log in instead.',
              SIGNUP_STEPS.INITIAL
            );
          } else {
            throw new SignupError(authResult, SIGNUP_STEPS.INITIAL);
          }
        }
        return { success: true, newAccount: true };

      case 'profile':
        return { success: true };

      case 'organization':
        const createOrgResult = await createOrganization({
          orgName: organizationDetails.companyName,
          email: user.email,
          companyAddress: organizationDetails.address,
          companyCity: organizationDetails.city,
          companyState: organizationDetails.state,
          companyZip: organizationDetails.zip,
          userProfile: userProfile
        });

        return {
          success: true,
          organizationId: createOrgResult.data.orgId,
        };

      default:
        throw new SignupError('Invalid signup step', SIGNUP_STEPS.INITIAL);
    }
  } catch (error) {
    throw new SignupError(
      error.message || 'Failed to complete signup process',
      error.step || SIGNUP_STEPS.INITIAL,
      error
    );
  }
}; 